export interface RingtoneOptions {
  maxDuration?: number | undefined;
  loop?: boolean | undefined;
}

export class RingtoneManager {
  private audio: HTMLAudioElement | null = null;
  private isPlaying = false;
  private timeoutId: number | null = null;

  constructor(private options: RingtoneOptions = {}) {
    this.options = {
      maxDuration: 45000,
      loop: true,
      ...options,
    };
  }

  play(): void {
    if (this.isPlaying) {
      return;
    }

    if (!this.audio) {
      this.audio = new Audio('/sounds/incoming-call.mp3');
      this.audio.loop = this.options.loop ?? true;
      this.audio.volume = 0.7;
    }

    this.isPlaying = true;

    const playPromise = this.audio.play();

    if (playPromise !== undefined) {
      playPromise.catch(() => {
        this.isPlaying = false;
      });
    }

    if (this.options.maxDuration) {
      this.timeoutId = window.setTimeout(() => {
        this.stop();
      }, this.options.maxDuration);
    }
  }

  stop(): void {
    if (!this.audio || !this.isPlaying) {
      return;
    }

    this.audio.pause();
    this.audio.currentTime = 0;
    this.isPlaying = false;

    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  destroy(): void {
    this.stop();
    if (this.audio) {
      this.audio.remove();
      this.audio = null;
    }
  }

  getIsPlaying(): boolean {
    return this.isPlaying;
  }
}
